// Find all YouTube video links on the page
document.querySelectorAll('a[href*="youtube.com/watch"]').forEach((link) => {
  // Create a <dialog> element
  const dialog = document.createElement("dialog");
  dialog.style.width = "80%";
  dialog.style.maxWidth = "1280px";
  dialog.style.top = "50%";
  // dialog.style.aspectRatio = "16 / 9";
  dialog.style.border = "16px solid white";
  dialog.style.padding = "0";
  dialog.style.transform = "translateY(-50%)";

  // Embed the YouTube video inside the <dialog>
  const iframe = document.createElement("iframe");
  iframe.src = `${link.href.replace("watch?v=", "embed/")}?rel=0`;
  iframe.style.width = "100%";
  iframe.style.aspectRatio = "16 / 9";
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  );
  iframe.setAttribute("allowfullscreen", true);

  dialog.appendChild(iframe);
  document.body.appendChild(dialog);

  // Add click event to open the <dialog> as a modal
  link.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent navigation to the URL
    dialog.showModal(); // Open the modal
  });

  // Add event to close the modal when clicked outside
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) {
      dialog.close(); // Close the modal
    }
  });
});
